export const yearsOfExperienceInBreadSales = [
      {
        value: 1,
        label: `1 year`,
      },
      {
        value: 2,
        label: `2 years`,
      },
      {
        value: 3,
        label: `3 years`,
      },
      {
        value: 4,
        label: `4 years`,
      },
      {
        value: 5,
        label: `5 years and above`,
      },
];


// Helper to format full date
export function formatFullDate(date) {
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}


// timeUtils.js
export function formatRelativeTime(dateInput) {
  const date = new Date(dateInput);
  const now = new Date();
  const diffMs = now - date;

  const seconds = Math.floor(diffMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  // --- Under 1 minute ---
  if (seconds < 60) {
    return { display: `${seconds} secs ago`, full: formatFullDate(date) };
  }

  // --- Under 1 hour ---
  if (minutes < 60) {
    return { display: `${minutes} mins ago`, full: formatFullDate(date) };
  }

  // --- Under 24 hours ---
  if (hours < 24) {
    return { display: `${hours} hour${hours > 1 ? "s" : ""} ago`, full: formatFullDate(date) };
  }

  // --- Over 24 hours → use full date ---
  return { display: formatFullDate(date), full: formatFullDate(date) };
}
